import { fetchEnvironment } from '@/services/api';

export default {
  namespaced: true,
  state: {
    locale: null,
  },
  getters: {
    locale(state) {
      return typeof state.locale === 'string' ? state.locale.toLowerCase() : null;
    },
  },
  actions: {
    fetch: ({ commit, rootState }) => {
      return fetchEnvironment(rootState.environmentId).then(({ data: { environment } }) => {
        commit('SET_LOCALE', (environment.country_code || 'NL').toLowerCase());
      });
    },
  },
  mutations: {
    SET_LOCALE: (state, value) => {
      state.locale = value;
    },
  },
};
